const PAGINATION = {
  DEFAULT_PAGE_SIZE: 12,
  DEFAULT_PAGE: 1,
  DEFAULT_PAGINATION_SIZE_OPTIONS: [12, 24, 60, 120],
}

export default PAGINATION
